import React from "react"

import {useKlaraSummaryQuery} from "../../queries/klaraDashboard.ts"
import {getPeriodRange} from "./period.ts"
import {wallClock} from "./sessions.ts"
import {useKlaraPeriod} from "./useKlaraPeriod.ts"

/** The team-wide summary of the selected period; every caller shares one cached request. */
export const useKlaraSummary = () => {
  const [period] = useKlaraPeriod()
  // The picker computes preset dates on the browser's calendar.
  const range = React.useMemo(() => getPeriodRange(period), [period])

  return useKlaraSummaryQuery(range)
}

export type TDashboardClock = {
  /** The dashboard time zone; undefined (the browser's zone) until the summary has loaded. */
  timeZone: string | undefined
  /** The backend's "now" for relative labels such as Today / Yesterday. */
  asOf: Date
}

/** The time zone and current time the dashboard labels are read in, as the backend counts them. */
export const useDashboardClock = (): TDashboardClock => {
  const summary = useKlaraSummary().data?.data

  return {timeZone: summary?.time_zone, asOf: summary ? new Date(summary.as_of) : new Date()}
}

/** The dashboard's calendar date of its "now" (YYYY-MM-DD). */
export const dashboardDay = ({asOf, timeZone}: TDashboardClock): string => {
  const {year, month, day} = wallClock(asOf, timeZone)
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`
}
